export enum LicencedProductFeatures {
  CherryPass_PushNotifications = "CherryPass_PushNotifications",
}
